import { browserFetchWithPolyfill } from "../../HttpClient/FetchImplementation/BrowserFetchWithPolyfill";
import { testKonturApiPicklist } from "../../EndPoints";
import { PicklistApiClient } from "../../PicklistApiClient/PicklistApiClient";

import { IDigestApiClient } from "./IDigestApiClient";
import { DigestApiClient } from "./DigestApiClient";

export function createTestDigestApiClient(): IDigestApiClient {
    const picklistApiClient = new PicklistApiClient(
        browserFetchWithPolyfill,
        testKonturApiPicklist,
        undefined,
        undefined
    );
    return new DigestApiClient(picklistApiClient);
}
